/* eslint-disable object-curly-newline */
import React from 'react';
import {
  Select,
  MenuItem,
  Typography,
  FormControlLabel,
  makeStyles,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import TranslateIcon from '@material-ui/icons/Translate';

const UI_LANGUAGE_STORAGE_KEY = 'uiLanguage';

const useStyles = makeStyles({
  selectRoot: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 10,
    paddingRight: 36, // espace flèche
    fontSize: 14,
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
});
export default function UiLanguageSelect() {
  const { i18n, t } = useTranslation();
  const classes = useStyles();

  const current = (i18n.language || localStorage.getItem(UI_LANGUAGE_STORAGE_KEY) || 'fr').slice(0, 2);

  const handleChange = (e) => {
    const next = e.target.value;
    localStorage.setItem(UI_LANGUAGE_STORAGE_KEY, next);
    i18n.changeLanguage(next);
  };

  const getFlag = (lang) => {
    switch (lang) {
      case 'fr':
        return '🇫🇷';
      case 'en':
        return '🇬🇧';
      case 'pt':
        return '🇵🇹';
      case 'nl':
        return '🇳🇱';
      case 'de':
        return '🇩🇪';
      case 'lu':
        return '🇱🇺';
      default:
        return '';
    }
  };

  const getLanguageName = (lang) => {
    switch (lang) {
      case 'fr':
        return 'Français';
      case 'en':
        return 'English';
      case 'pt':
        return 'Português';
      case 'nl':
        return 'Nederlands';
      case 'de':
        return 'Deutsch';
      case 'lu':
        return 'Lëtzebuergesch';
      default:
        return '';
    }
  };

  return (
    <FormControlLabel
      style={{
        margin: '0px',
        padding: '0px',
      }}
      label={(
        <Typography
          variant="button"
          style={{
            marginRight: '10px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          <TranslateIcon style={{ fontSize: '18px' }} />
          <span>{t('layout.traduction', 'Traduction')}</span>
        </Typography>
      )}
      labelPlacement="start"
      control={(
        <Select
          value={current}
          variant="outlined"
          style={{
            backgroundColor: 'white',
            marginRight: '25px',
          }}
          renderValue={(value) => (
            <div className={classes.menuItem}>
              <span>{getFlag(value)}</span>
              <span>{getLanguageName(value)}</span>
            </div>
          )}
          inputProps={{
            classes: {
              root: classes.selectRoot,
            },
          }}
          onChange={handleChange}
        >
          <MenuItem value="fr">
            <div className={classes.menuItem}>
              <span>{getFlag('fr')}</span>
              <span>Français</span>
            </div>
          </MenuItem>
          <MenuItem value="en">
            <div className={classes.menuItem}>
              <span>{getFlag('en')}</span>
              <span>English</span>
            </div>
          </MenuItem>
          <MenuItem value="pt">
            <div className={classes.menuItem}>
              <span>{getFlag('pt')}</span>
              <span>Português</span>
            </div>
          </MenuItem>
          <MenuItem value="nl">
            <div className={classes.menuItem}>
              <span>{getFlag('nl')}</span>
              <span>Nederlands</span>
            </div>
          </MenuItem>
          <MenuItem value="de">
            <div className={classes.menuItem}>
              <span>{getFlag('de')}</span>
              <span>Deutsch</span>
            </div>
          </MenuItem>
          <MenuItem value="lu">
            <div className={classes.menuItem}>
              <span>{getFlag('lu')}</span>
              <span>Lëtzebuergesch</span>
            </div>
          </MenuItem>
        </Select>
      )}
    />

  );
}
